export default __webpack_public_path__ + "static/title_right-eccfa66635cd10581a917dea4b74f121.png";